import template from './modal.tmpl.html';
import controller from './modal.controller';

const WsModalComponent = {
  template,
  controller,
  bindings: {
    disabled: '<',
    secondary: '<',
    invalid: '<',
    hideAction: '<',
    dismissTop: '<',
    suppressTriggerButton: '<',
    suppressDismissOnOutsideClick: '<',
    triggerId: '@',
    triggerClass: '@',
    onAction: '&',
    onCancel: '&',
  },
  transclude: {
    trigger: '?wsModalTrigger',
    body: 'wsModalBody',
    action: '?wsModalAction',
    dismiss: '?wsModalDismiss',
    progress: '?wsModalProgress',
  },
};

export default WsModalComponent;



// WEBPACK FOOTER //
// ./src/layout/modal/index.js